import HttpCliente from "../HttpCliente";

export const getUsuarios = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/Usuario/ObtenerUsuarios", {
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "text/plain",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const postUsuario = (token, usuario) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/Usuario/CrearUsuario", usuario, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const putUsuario = (token, usuario) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/Usuario/EditarUsuario", usuario, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const addRelClienteUsuario = (token, relClienteUsuario) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/Usuario/AgregarRelacionClienteUsuario", relClienteUsuario, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteRelClienteUsuario = (token, relClienteUsuario) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/Usuario/EliminarRelacionClienteUsuario", relClienteUsuario, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      }); 
    });
  };

export const getClientesUsuario = (token, idUsuario) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Usuario/ObtenerClientesUsuario/${idUsuario}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "text/plain",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getUsuarioId = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Usuario/ObtenerUsuarioId/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "application/json",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const editarContrasena = (token, editarContraseñaDto) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/Usuario/EditarContraseña", editarContraseñaDto, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};